import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ContactPerson from '../Models/ContactPerson/ContactPerson';
import FluidImage from 'components/FluidImage';
import OnPageEditing from 'components/OnPageEditing';
import Button from 'components/Button';
import LinkButton from '../Models/LinkButton/LinkButton';
import css from './ContactBlock.module.scss';

function name(person) {
    return `${person.firstName} ${person.lastName}`;
}

const Person = ({
    onPageEditing,
    person,
    contactLength,
    size,
    sendEmailLabel,
    hideEmailAddress,
    small
}) => (
    <div className={classNames(css['person-block'], {
        [css['left-aligned']]: contactLength <= 2,
    })}>
        <OnPageEditing active={onPageEditing} property="ProfilePicture">
            {person.profilePicture && (
                <FluidImage
                    altText={name(person)}
                    className={classNames(css.circle, css["circle-"+size])}
                    image={person.profilePicture}
                />
            )}
        </OnPageEditing>
        <div className={classNames(css['info'], {
            [css['left-aligned']]: contactLength <= 2 && !small,
            [css['no-image']]: !person.profilePicture,
        })}>
            <div className={css['detailed-info']}>
                <p className={css.name}>
                    <OnPageEditing active={onPageEditing} component="span" property="FirstName">{person.firstName}</OnPageEditing> <OnPageEditing active={onPageEditing} component="span" property="LastName">{person.lastName}</OnPageEditing>
                </p>
                <OnPageEditing active={onPageEditing} property="Title">
                    <p className={css.title}>{person.title}</p>
                </OnPageEditing>
                <OnPageEditing active={onPageEditing} property="Department">
                    <p className={css.department}>{person.department}</p>
                </OnPageEditing>
            </div>
            <div className={css['contact-info']}>
                {!hideEmailAddress && (
                    <OnPageEditing active={onPageEditing} property="EmailAddress">
                        {person.emailAddress &&<p><a data-name={name(person)} href={`mailto:${person.emailAddress}`}>{sendEmailLabel || person.emailAddress}</a></p>}
                    </OnPageEditing>
                )}
                
                <OnPageEditing active={onPageEditing} property="Phone">
                    {person.phone &&<p><a data-name={name(person)} href={`tel:${person.phone}`}>{person.phone}</a></p>}
                </OnPageEditing>
            </div>
        </div>
    </div>
);

Person.propTypes = Object.assign({}, ContactPerson.propTypes);

const ContactBlock = ({
    className,
    blockId,
    contentType,
    heading,
    contacts,
    small,
    sendEmailLabel,
    hideEmailAddress,
    seeAllLink
}) => {
    const size = (small || contacts.length > 1) ? "medium" : "large";

    return (
        <div
            className={classNames(css.contacts, className, {
                [css.small]: small
            })}
            data-block={blockId}
        >
            <OnPageEditing active={contentType === 'ContactPersonListBlock'} property="Heading">
                {heading && <h2 className={css.heading}>{heading}</h2>}
            </OnPageEditing>
            <OnPageEditing active={contentType === 'ContactPersonListBlock'} property="Contacts">
                <ul className={css['block-wrapper']} >
                    {contacts.map((person, i) => (
                        <li key={i}>
                            <Person
                                contactLength={contacts.length}
                                onPageEditing={contentType !== 'ContactPersonListBlock'}
                                person={person}
                                size={size}
                                sendEmailLabel={sendEmailLabel}
                                hideEmailAddress={hideEmailAddress}
                                small={small}
                            />
                        </li>
                    ))}
                </ul>
            </OnPageEditing>
            <OnPageEditing active={contentType === 'ContactPersonListBlock'} property="SeeAllLink">
                {seeAllLink && <Button 
                    className={css['see-all-link']} 
                    secondary 
                    href={seeAllLink.url}
                >{seeAllLink.text}</Button>}
            </OnPageEditing>
        </div>
    );
};

ContactBlock.propTypes = {
    className: PropTypes.string,
    blockId: PropTypes.number,
    contentType: PropTypes.string,
    heading: PropTypes.string,
    contacts: PropTypes.arrayOf(PropTypes.shape(ContactPerson.propTypes)).isRequired,
    small: PropTypes.bool,
    sendEmailLabel: PropTypes.string.isRequired,
    hideEmailAddress: PropTypes.bool,
    seeAllLink: PropTypes.shape(LinkButton.propTypes)
};

export default ContactBlock;



// WEBPACK FOOTER //
// ./src/components/ContactBlock/ContactBlock.jsx